
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'ButtonComponent',
  emits: ['clicked'],
  props: {
    disabled: {
      type: Boolean
    },
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    clicked(): void {
      this.$emit('clicked');
    }
  }
});
